import { useState } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import HTML from "../assets/icons/icon-html.png";
import CSS from "../assets/icons/icon-css.png";
import JavaScript from "../assets/icons/icon-javascript.png";
import TypeScript from "../assets/icons/icon-typescript.svg";
import ReactImg from "../assets/icons/icon-react.png";
import NextImg from "../assets/icons/icon-nextjs.svg";
import Node from "../assets/icons/icon-node.png";
import Nest from "../assets/icons/icon-nestjs.svg";
import GQL from "../assets/icons/icon-graphql.png";
import Hasura from "../assets/icons/icon-hasura.svg";
import Apollo from "../assets/icons/icon-apollo-graphql.svg";
import Express from "../assets/icons/icon-express.svg";
import REST from "../assets/icons/icon-rest-api.png";
import Docker from "../assets/icons/icon-docker.svg";
import Python from "../assets/icons/icon-python.png";
import Cpp from "../assets/icons/icon-cpp.png";
import FireBase from "../assets/icons/icon-firebase.png";
import Tailwind from "../assets/icons/icon-tailwind.png";
import Shadcn from "../assets/icons/icon-shadcn-ui.svg";
import Bootstrap from "../assets/icons/icon-bootstrap.svg";
import Mongo from "../assets/icons/icon-mongo.png";
import SQL from "../assets/icons/icon-sql.png";
import Postgres from "../assets/icons/icon-postgres.png";
import Supabase from "../assets/icons/icon-supabase-logo.svg";
import Kotlin from "../assets/icons/icon-kotlin.png";
import Java from "../assets/icons/icon-java.png";

const Skills = () => {
  const [expandedCategories, setExpandedCategories] = useState({});

  const mainSkills = [
    { name: "React", img: ReactImg },
    { name: "Node.js", img: Node },
    { name: "TypeScript", img: TypeScript },
    { name: "Hasura", img: Hasura },
  ];

  const skillCategories = [
    {
      id: "frontend",
      title: "Frontend Development",
      icon: "🎨",
      skills: [
        { name: "Next.js", img: NextImg, level: "Advanced" },
        { name: "JavaScript", img: JavaScript, level: "Expert" },
        { name: "HTML5", img: HTML, level: "Expert" },
        { name: "CSS/SCSS", img: CSS, level: "Expert" },
        { name: "Tailwind", img: Tailwind, level: "Expert" },
        { name: "Shadcn UI", img: Shadcn, level: "Advanced" },
        { name: "Bootstrap", img: Bootstrap, level: "Advanced" },
      ]
    },
    {
      id: "backend",
      title: "Backend Development", 
      icon: "⚙️",
      skills: [
        { name: "NestJS", img: Nest, level: "Advanced" },
        { name: "GraphQL", img: GQL, level: "Expert" },
        { name: "Apollo GraphQL", img: Apollo, level: "Expert" },
        { name: "Express.js", img: Express, level: "Expert" },
        { name: "REST APIs", img: REST, level: "Expert" },
        { name: "Docker", img: Docker, level: "Intermediate" },
      ]
    },
    {
      id: "database",
      title: "Database & Storage",
      icon: "🗄️", 
      skills: [
        { name: "PostgreSQL", img: Postgres, level: "Expert" },
        { name: "MongoDB", img: Mongo, level: "Advanced" },
        { name: "MySQL", img: SQL, level: "Advanced" },
        { name: "Firebase", img: FireBase, level: "Intermediate" },
        { name: "Supabase", img: Supabase, level: "Intermediate" },
      ]
    },
    {
      id: "languages",
      title: "Programming Languages",
      icon: "💻",
      skills: [
        { name: "C++", img: Cpp, level: "Advanced" },
        { name: "Python", img: Python, level: "Intermediate" },
        { name: "Java", img: Java, level: "Intermediate" },
        { name: "Kotlin", img: Kotlin, level: "Intermediate" },
      ]
    }
  ];

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const getLevelColor = (level) => {
    switch (level) {
      case "Expert":
        return "text-cyan-400";
      case "Advanced":
        return "text-green-400";
      case "Intermediate":
        return "text-yellow-400";
      default:
        return "text-gray-400";
    }
  };

  return (
    <div
      name="skills"
      className="w-full min-h-screen bg-[#0a192f] text-gray-300 py-20"
    >
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="pb-12">
          <h2 className="text-4xl sm:text-5xl font-bold inline-block border-b-4 border-cyan-600">
            Skills & Technologies
          </h2>
          <p className="text-[#8892b0] text-lg mt-4">
            Technologies and tools I work with professionally
          </p>
        </div>

        {/* Main Skills Highlight */}
        <div className="bg-[#112240] rounded-xl border border-cyan-600 border-opacity-20 p-8 mb-12">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">Core Technologies</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {mainSkills.map((skill) => (
              <div key={skill.name} className="flex flex-col items-center space-y-3 group">
                <img
                  className="w-16 h-16 object-contain group-hover:scale-110 transition-transform duration-300"
                  src={skill.img}
                  alt={`${skill.name} icon`}
                />
                <p className="text-white font-semibold text-lg">{skill.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Expandable Categories */}
        <div className="space-y-4">
          {skillCategories.map((category) => (
            <div key={category.id} className="bg-[#112240] rounded-xl border border-cyan-600 border-opacity-20 overflow-hidden">
              <button
                onClick={() => toggleCategory(category.id)}
                className="w-full p-6 flex items-center justify-between hover:bg-[#1a2332] transition-colors duration-300"
              >
                <div className="flex items-center gap-4">
                  <span className="text-2xl">{category.icon}</span>
                  <h3 className="text-xl font-bold text-white">{category.title}</h3>
                  <span className="text-[#8892b0] text-sm">({category.skills.length} skills)</span>
                </div>
                {expandedCategories[category.id] ? 
                  <HiChevronUp className="text-2xl text-cyan-400" /> : 
                  <HiChevronDown className="text-2xl text-cyan-400" />
                }
              </button>
              
              {expandedCategories[category.id] && (
                <div className="px-6 pb-6">
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                    {category.skills.map((skill) => (
                      <div key={skill.name} className="bg-[#0a192f] p-4 rounded-lg border border-cyan-600 border-opacity-10 hover:border-opacity-30 transition-all duration-300 group">
                        <div className="flex flex-col items-center space-y-3">
                          <img
                            className="w-12 h-12 object-contain group-hover:scale-110 transition-transform duration-300"
                            src={skill.img}
                            alt={`${skill.name} icon`}
                          />
                          <div className="text-center">
                            <p className="text-white font-medium">{skill.name}</p>
                            <p className={`text-xs mt-1 ${getLevelColor(skill.level)}`}>
                              {skill.level}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
